<template>
  <div class="">
    <div class="top-head col-12 p-3 bg-white">
      <b-row>
        <b-col>
          <p class="label m-0 p-0 mb-3  ">
            Updated
            <em>{{ applicationData.updatedAt | moment("ll") }}</em
            >, Created
            <em>{{ applicationData.createdAt | moment("ll") }}</em>
          </p>
          <h5>Application #{{ applicationId }}</h5>
          <b-row class="">
            <b-col class="border-right">
              <p class="m-0 p-0">
                Loan-
                {{
                  (vehicleSelected.MRP - applicationData.marginmoney) | currency
                }}
              </p>
            </b-col>
            <b-col class="border-right">
              <p class="m-0 p-0">IDFC First</p>
            </b-col>
            <b-col class="border-right">
              <p class="m-0 p-0">
                DP- {{ applicationData.marginmoney | currency }}
              </p>
            </b-col>
            <b-col class="">
              <p class="m-0 p-0">
                Tenure- {{ applicationData.tenure * 12 }} months
              </p>
            </b-col>
          </b-row>
          <div class="d-flex col-12 m-0 p-0 mt-2">
            <p class="m-0 p-0 pr-3">
              {{ vehicleSelected.model }} | {{ vehicleSelected.ignition }}
            </p>
          </div>
        </b-col>
        <b-col class="text-right">
          <b-button
            @click="process"
            class="ml-2"
            variant="outline-primary"
            size="sm"
          >
            <i class="fas fa-play-circle"></i>
            Process with Changes ({{ applicationData.backendUpdateTrial }} trial
            done)
          </b-button>
          <b-button
            @click="learn = true"
            variant="outline-danger"
            size="sm"
            class="ml-2"
          >
            Learn How?
          </b-button>
        </b-col>
      </b-row>
      <div class="alerts-toggle text-right col-12 m-0 p-0">
        <b-row>
          <b-col class="text-left text-primary">
            <div class="d-flex col-12 m-0 p-0">
              <div class="border-right pr-2">
                <p class="m-0 p-0">{{ status }}</p>
              </div>
              <div class="pl-2">
                <p class="m-0 p-0">{{ subStatus }}</p>
              </div>
            </div>
          </b-col>
          <b-col class="text-right">
            <b-checkbox switch v-model="editMode">EDIT MODE</b-checkbox>
          </b-col>
        </b-row>
      </div>
    </div>
    <div v-if="loanDetailsClient" class="text-left col-6 m-0 p-0 mt-3">
      <p class="text-primary">{{ loanDetailsClient.MessageDisplay }}</p>
      <div class="">
        <b-alert
          show
          :variant="
            loanDetailsClient.status.error.length > 0 ? 'danger' : 'success'
          "
        >
          <p class="m-0 p-0">
            {{ loanDetailsClient.status.responseMessage }}
          </p>
          <p class="m-0 p-0">
            {{
              loanDetailsClient.status.error.length > 0
                ? loanDetailsClient.status.error[0].errorDescription
                : ""
            }}
          </p>
        </b-alert>
      </div>
    </div>
    <div class="mt-4">
      <b-row>
        <b-col cols="6">
          <b-card class="m-0 px-4 py-4 border-0 mb-4" body-class="m-0 p-0">
            <h5>Personal Details</h5>
            <div>
              <div class="mb-2">
                <p class="label m-0 p-0 pb-1">Full Name</p>
                <b-row>
                  <b-col>
                    <b-form-input
                      :disabled="!editMode"
                      :class="editMode ? '' : 'border-0'"
                      placeholder="first name"
                      v-model="obj.firstName"
                    />
                  </b-col>
                  <b-col>
                    <b-form-input
                      :disabled="!editMode"
                      :class="editMode ? '' : 'border-0'"
                      placeholder="last name"
                      v-model="obj.lastName"
                    />
                  </b-col>
                </b-row>
              </div>
              <div class="mb-2">
                <b-form-group label="Gender" class="label">
                  <b-row>
                    <b-col cols="4">
                      <b-form-radio
                        :disabled="!editMode"
                        :class="editMode ? '' : 'border-0'"
                        v-model="obj.gender"
                        name="gender"
                        value="Male"
                        >Male</b-form-radio
                      >
                    </b-col>
                    <b-col>
                      <b-form-radio
                        :disabled="!editMode"
                        :class="editMode ? '' : 'border-0'"
                        v-model="obj.gender"
                        name="gender"
                        value="Female"
                        >Female</b-form-radio
                      >
                    </b-col>
                  </b-row>
                </b-form-group>
              </div>
              <div class="mb-2">
                <b-form-group label="Marital Status" class="label">
                  <b-row>
                    <b-col cols="4">
                      <b-form-radio
                        :disabled="!editMode"
                        :class="editMode ? '' : 'border-0'"
                        v-model="obj.maritalStatus"
                        name="some-radios"
                        value="Married"
                        >Married</b-form-radio
                      >
                    </b-col>
                    <b-col cols="4">
                      <b-form-radio
                        :disabled="!editMode"
                        :class="editMode ? '' : 'border-0'"
                        v-model="obj.maritalStatus"
                        name="some-radios"
                        value="Single"
                        >Single</b-form-radio
                      >
                    </b-col>
                  </b-row>
                </b-form-group>
              </div>
              <div class="mb-2">
                <p class="label m-0 p-0 pb-1">Date of Birth</p>
                <input
                  type="date"
                  :disabled="!editMode"
                  :class="editMode ? '' : 'border-0'"
                  class="form-control"
                  :max="maxDateOfBirth"
                  v-model="obj.dateOfBirth"
                />
              </div>
              <div>
                <b-alert show variant="info" v-if="coapplicantRequired">
                  <p class="label-s m-0 p-0">
                    Note: Mandatory co-applicant is required for age between
                    <strong>18</strong> - <strong>21</strong> years.
                  </p>
                </b-alert>
              </div>
            </div>
          </b-card>
        </b-col>
        <b-col cols="6">
          <b-card class="m-0 px-4 py-4 border-0 mb-4" body-class="m-0 p-0">
            <h5>Address</h5>
            <b-row>
              <b-col class="mb-2">
                <p class="label m-0 p-0 pb-1">Address Proof</p>
                <b-form-select
                  :disabled="!editMode"
                  :class="editMode ? '' : 'border-0'"
                  v-model="addressType"
                  :options="addressTypeList"
                />
              </b-col>
              <b-col class="mb-2">
                <p class="label m-0 p-0 pb-1">Current Residential Status</p>
                <b-form-select
                  :disabled="!editMode"
                  :class="editMode ? '' : 'border-0'"
                  v-model="propertyStatus"
                  :options="propertyStatusList"
                />
              </b-col>
            </b-row>
            <div class="mb-2">
              <p class="label m-0 p-0 pb-1">Full Address</p>
              <b-row>
                <b-col>
                  <b-form-textarea
                    :disabled="!editMode"
                    :class="editMode ? '' : 'border-0'"
                    placeholder="Flat Number/ Building name/Society & Street/Locality/Area"
                    v-model="addressLine1"
                    rows="5"
                    max-rows="6"
                  ></b-form-textarea>
                </b-col>
                <b-col>
                  <b-form-textarea
                    :disabled="!editMode"
                    :class="editMode ? '' : 'border-0'"
                    placeholder="Flat Number/ Building name/Society & Street/Locality/Area"
                    v-model="addressLine2"
                    rows="5"
                    max-rows="6"
                  ></b-form-textarea>
                </b-col>
                <b-col>
                  Pincode
                  <b-input
                    :disabled="!editMode"
                    :class="editMode ? '' : 'border-0'"
                    type="number"
                    v-model="pincode"
                  ></b-input>
                </b-col>
              </b-row>
              <b-row class="mt-2 label">
                <b-col>
                  State
                  <b-input
                    :disabled="!editMode"
                    :class="editMode ? '' : 'border-0'"
                    type="text"
                    v-model="state"
                  ></b-input>
                </b-col>
                <b-col>
                  City
                  <b-input
                    :disabled="!editMode"
                    :class="editMode ? '' : 'border-0'"
                    type="text"
                    v-model="city"
                  ></b-input>
                </b-col>
              </b-row>
            </div>
          </b-card>
        </b-col>

        <b-col cols="6">
          <b-card class="m-0 px-4 py-4 border-0 mb-4" body-class="m-0 p-0">
            <h5>Employment</h5>
            <b-row>
              <b-col cols="6" class="mb-2">
                <p class="label m-0 p-0 pb-1">Employment Status</p>
                <b-form-select
                  :disabled="!editMode"
                  :class="editMode ? '' : 'border-0'"
                  v-model="employmentType"
                  :options="employmentTypeList"
                />
              </b-col>
              <b-col cols="6" class="mb-2">
                <p class="label m-0 p-0 pb-1">Employer/Organisation/Company</p>
                <b-form-input
                  :disabled="!editMode"
                  :class="editMode ? '' : 'border-0'"
                  v-model="employerName"
                ></b-form-input>
              </b-col>
              <b-col cols="6" class="mb-2">
                <p class="label m-0 p-0 pb-1">Current Annual Income</p>
                <b-form-input
                  :disabled="!editMode"
                  :class="editMode ? '' : 'border-0'"
                  v-model="annualGrossSalary"
                  type="number"
                ></b-form-input>
              </b-col>
              <b-col cols="6" class="mb-2">
                <p class="label m-0 p-0 pb-1">
                  Select a document to verify yourself
                </p>
                <b-form-select
                  :disabled="!editMode"
                  :class="editMode ? '' : 'border-0'"
                  v-model="selectedDocument"
                  :options="documents"
                />
              </b-col>
              <b-col cols="6" class="mb-2" v-if="selectedDocument">
                <p class="label m-0 p-0 pb-1">
                  Enter {{ selectedDocument }} number.
                </p>
                <b-form-input
                  :disabled="!editMode"
                  :class="editMode ? '' : 'border-0'"
                  v-model="documentValue"
                  type="text"
                ></b-form-input>
              </b-col>
            </b-row>
          </b-card>
        </b-col>

        <b-col cols="6">
          <b-card class="m-0 px-4 py-4 border-0 mb-4" body-class="m-0 p-0">
            <h5>Communication</h5>
            <b-row>
              <b-col class="mb-2">
                <p class="label m-0 p-0 pb-1">Your Email Address</p>
                <b-form-input
                  :disabled="!editMode"
                  :class="editMode ? '' : 'border-0'"
                  v-model="obj.emailId"
                  type="email"
                ></b-form-input>
              </b-col>
              <b-col class="mb-2">
                <p class="label m-0 p-0 pb-1">Contact Number</p>
                <div class="p-2 border radius">
                  <h6 class="m-0 p-0 label">
                    {{ obj.mobileNumber }}
                    <span class="my-auto text-success m-0 p-0 label-s">
                      Verified
                    </span>
                  </h6>
                </div>
              </b-col>
            </b-row>
          </b-card>
          <b-card>
            Scheme ID
            <div class="col-4 m-0 p-0 mb-4">
              <b-select
                v-model="schemeSelected"
                :disabled="!editMode"
                :class="editMode ? '' : 'border-0'"
              >
                <b-select-option
                  :value="data"
                  v-for="(data, index) in schemes"
                  :key="index"
                >
                  {{ data.assetType }}
                </b-select-option>
              </b-select>
            </div>

            <b-alert show>
              Scheme ID needs to be changed only if error is “Applied LTV is not
              eligible in said scheme”. For such case please change scheme to
              Test Program and click Save and Update, after that click on
              Process with Changes to reinitiate.
            </b-alert>
          </b-card>
        </b-col>

        <b-col cols="6">
          <b-card>
            <b-select
              v-model="vehicleSelected"
              :disabled="!editMode"
              :class="editMode ? '' : 'border-0'"
            >
              <b-select-option
                :value="data"
                v-for="(data, index) in vehicleList"
                :key="index"
              >
                {{ data.model }}
              </b-select-option>
            </b-select>
            <b-row cols="mt-3">
              <b-col>
                Down Payment
                <b-input
                  :disabled="!editMode"
                  :class="editMode ? '' : 'border-0'"
                  type="input"
                  class=""
                  v-model="obj.marginmoney"
                ></b-input>
              </b-col>
              <b-col>
                Tenure
                <b-input
                  :disabled="!editMode"
                  :class="editMode ? '' : 'border-0'"
                  type="number"
                  v-model="obj.tenure"
                ></b-input>
              </b-col>
            </b-row>
            <b-alert
              show
              :variant="dpCalc.valid ? 'primary' : 'danger'"
              class="mt-3"
            >
              <i v-if="dpCalc.valid" class="fas fa-check-circle"></i>
              <i v-else class="fas fa-times-circle"></i>
              {{ dpCalc.message }}
            </b-alert>
          </b-card>
        </b-col>
      </b-row>
    </div>
    <div class="text-center my-5 col-12">
      <b-button variant="primary" @click="saveAndProceed">
        Save and Update
      </b-button>
    </div>
    <b-modal
      class="m-2"
      no-close-on-backdrop
      centered
      hide-header
      hide-footer
      v-model="checkPincode"
    >
      <div class="p-3">
        <h2 class="text-success">
          <i class="fa-solid fa-binary-circle-check"></i>
        </h2>
        <h4>Service location check.</h4>
        <p class="label-n">
          We are servicable in only certain locations, please provide your PIN
          Code to begin.
        </p>
        <b-form-input
          v-model="pincode"
          autofocus
          placeholder="enter pincode"
          max="6"
          type="number"
        ></b-form-input>
        <div class="mt-4">
          <b-button @click="checkPincodeFn" block variant="primary">
            Check Pincode
          </b-button>
        </div>
        <div class="mt-3">
          <p class="text-danger label-s m-0 p-0">{{ errorMessage }}</p>
        </div>
      </div>
    </b-modal>
    <b-modal
      hide-footer
      hide-header
      v-model="loading"
      no-close-on-backdrop
      centered
      size="sm"
    >
      <div class="text-center">
        Please Wait
      </div>
    </b-modal>
    <b-modal v-model="learn" hide-header centered size="md" ok-only>
      <h4>How to Apply Changes?</h4>
      <div class="col-12 mt-4">
        <b-row class="mb-3">
          <b-col cols="1">
            <i class="far fa-check-circle"></i>
          </b-col>
          <b-col>
            Confirm all details with the customer
          </b-col>
        </b-row>
        <b-row class="mb-3">
          <b-col cols="1">
            <i class="far fa-edit"></i>
          </b-col>
          <b-col>
            Make Necessary Changes to the form.
          </b-col>
        </b-row>
        <b-row class="mb-3">
          <b-col cols="1">
            <i class="fal fa-hand-pointer"></i>
          </b-col>
          <b-col>
            Click on SAVE AND UPDATE to save changes before processing.
          </b-col>
        </b-row>
        <b-row class="mb-3">
          <b-col cols="1">
            <i class="far fa-check-circle"></i>
          </b-col>
          <b-col>
            Once Verified all the changes click PROCESS WITH CHANGES to apply
            changes to Partner.
          </b-col>
        </b-row>
      </div>
    </b-modal>
  </div>
</template>
<script>
import { HTTP2 } from "../../../axios/http-common";
import moment from "moment";
export default {
  data: () => ({
    learn: false,
    loanDetailsClient: "",
    status: "",
    subStatus: "",
    editMode: false,
    schemeSelected: {
      name: "Scheme 1",
      promoid: "11347",
      schemeId: "175",
      assetType: "Commuter",
      minDp: 10,
      maxDp: 80,
    },
    schemes: [
      {
        name: "Scheme 1",
        promoid: "13766",
        schemeId: "175",
        assetType: "Commuter",
        minDp: 10,
        maxDp: 80,
      },
      {
        name: "Scheme 4",
        promoid: "13769",
        schemeId: "68673",
        assetType: "Test",
        minDp: 10,
        maxDp: 80,
      },
      {
        name: "Scheme 2",
        promoid: "12277",
        schemeId: "62020",
        assetType: "Electric Registered",
        minDp: 10,
        maxDp: 80,
      },
      {
        name: "Scheme 3",
        promoid: "10828",
        schemeId: "62019",
        assetType: "Electric Non Registered",
        minDp: 10,
        maxDp: 80,
      },
    ],
    genderDataItems: [
      {
        value: "Male",
        icon: "fal fa-male",
      },
      {
        value: "Female",
        icon: "fal fa-female",
      },
    ],
    propertyStatusList: [
      {
        text: "Own house",
        value: "O",
      },
      {
        text: "Company Provided",
        value: "C",
      },
      {
        text: "Mortgaged",
        value: "M",
      },
      {
        text: "Relatives House",
        value: "H",
      },
      {
        text: "Rented",
        value: "R",
      },
    ],
    addressTypeList: [
      {
        text: "Residence Address",
        value: "RESIDENCE ADDRESS",
      },
      {
        text: "Office Address",
        value: "OFFICE ADDRESS",
      },
      {
        text: "Permanent Address",
        value: "PERMANENT ADDRESS",
      },
    ],
    employmentTypeList: [
      {
        value: "Salaried",
        text: "Salaried",
      },
      {
        value: "Self Employed",
        text: "Self Employed",
      },
    ],
    documents: [
      { value: "PAN", text: "PAN Card" },
      { value: "Aadhar Card", text: "Aadhar Card" },
      { value: "Passport", text: "Passport" },
    ],
    pincode: null,
    step: 1,
    pincodeServicable: true,
    checkPincode: false,
    obj: {
      gender: "",
      maritalStatus: "",
      firstName: null,
      lastName: null,
      fatherFirstName: null,
      fatherLastName: null,
      applicantType: "Applicant",
      mobileNumber: null,
      emailId: null,
      dateOfBirth: null,
      assetId: null,
      tenure: null,
      marginmoney: null,
    },
    addressLine1: null,
    addressLine2: null,
    employmentType: "",
    employerName: null,
    annualGrossSalary: null,
    addressType: "",
    propertyStatus: "R",
    otp: null,
    numberRequired: [],
    formFound: false,
    formToPopulate: "",
    addressOneInput: "",
    addressTwoInput: "",
    pincodeData: "",
    errorMessage: "",
    fullAddress: "",
    selectedDocument: "",
    loading: false,
    documentValue: "",
    vehicleSelected: "",
    applicationData: "",
    state: "",
    city: "",
    vehicleList: "",
  }),
  created() {
    this.applicationId = this.$route.params.id;
    this.loadData();
  },
  watch: {
    applicationData(newValue) {
      this.status = newValue.status;
      this.subStatus = newValue.subStatus;
      this.obj.tenure = newValue.tenure;
      this.obj.marginmoney = newValue.marginmoney;
      this.obj.firstName = newValue.firstName;
      this.obj.lastName = newValue.lastName;
      this.obj.dateOfBirth = moment(newValue.dateOfBirth).format("YYYY-MM-DD");
      this.obj.emailId = newValue.emailId;
      this.obj.mobileNumber = newValue.mobileNumber;
      this.obj.maritalStatus = newValue.maritalStatus;
      this.obj.gender = newValue.gender;

      this.vehicleSelected = this.vehicleList.find((x) => {
        return (x.id = newValue.assetId);
      });

      this.addressLine1 = newValue.address[0].addressLine1;
      this.addressLine2 = newValue.address[0].addressLine2;
      this.pincode = newValue.address[0].pincode;
      this.state = newValue.address[0].state;
      this.city = newValue.address[0].city;
      this.addressType = newValue.address[0].addressType;
      this.propertyStatus = newValue.address[0].propertyStatus;

      this.employerName = newValue.employmentInfo[0].employerName;
      this.employmentType = newValue.employmentInfo[0].employmentType;
      this.annualGrossSalary = newValue.employmentInfo[0].annualGrossSalary;
      this.selectedDocument = newValue.identifier[0].type;
      this.documentValue = newValue.identifier[0].value;
      this.schemeSelected = newValue.scheme || {
        name: "Scheme 1",
        promoid: "11347",
        schemeId: "175",
        assetType: "Commuter",
        minDp: 10,
        maxDp: 80,
      };
    },
  },
  methods: {
    async loadData() {
      this.loading = true;
      try {
        var loan = await HTTP2.get(
          `/finance/check/loan/prod/${this.applicationId}`
        );
        this.loanDetailsClient = loan.data;

        var vehicle = await HTTP2.get("finance/vehicle");
        this.vehicleList = vehicle.data;

        var { data } = await HTTP2.post("/idfc/get/loan", {
          query: {
            applicationId: this.applicationId,
          },
        });
        this.applicationData = data.loanData ? data.loanData[0] : [];
      } finally {
        this.loading = false;
      }
    },
    async checkPincodeFn() {
      try {
        this.loading = true;
        this.pincodeServicable = true;
        const { data } = await HTTP2.get(
          `finance/checkpincode/${this.pincode}`
        );
        // console.log(data);
        if (data.err === 1) {
          this.pincodeServicable = false;
          this.errorMessage = data.message;
        } else {
          this.loadLocalCustomerData();
          this.checkPincode = false;
          this.pincodeData = data ? data[0] : data;
        }
      } finally {
        this.loading = false;
      }
    },
    async process() {
      if (
        confirm(
          "Are you sure? Please note that customers beaureu report will be hit and enquires made here will be reflected on report. Please cross check details and update before processing."
        )
      ) {
        this.loading = true;
        try {
          await HTTP2.post(
            "/finance/update/loan/idfc/prod/" + this.applicationId
          );
        } finally {
          this.loading = false;
          this.loadData();
        }
      }
    },
    saveAndProceed() {
      this.obj.employmentInfo = [
        {
          employmentType: this.employmentType,
          employerName:
            this.employmentStatus == "Salaried"
              ? this.companyName
              : "selfEmployed",
          annualGrossSalary: Number(this.annualGrossSalary),
        },
      ];
      this.obj.address = [
        {
          addressLine1: this.addressLine1,
          addressLine2: this.addressLine2,
          pincode: this.pincode.toString(),
          addressType: this.addressType,
          propertyStatus: this.propertyStatus,
          city: this.city,
          state: this.state,
        },
      ];
      this.obj.identifier = [
        {
          type: this.selectedDocument,
          value: this.documentValue,
        },
      ];
      this.obj.fullAddress = this.addressLine1 + " " + this.addressLine2;
      this.obj.assetId = this.vehicleSelected.id;
      // this.obj.tenure = this.obj.tenure;
      // this.obj.marginmoney = this.obj.marginmoney;
      this.obj.dateOfBirth = moment(this.obj.dateOfBirth).format("DD-MM-YYYY");
      this.obj.source = "Ontrack_Super";
      this.obj.scheme = this.schemeSelected;
      // console.log(this.obj);
      // save this locally
      try {
        HTTP2.post("/finance/update/loan/prod/" + this.applicationId, this.obj);
        console.log(this.obj);
      } catch {
        alert("Some error occured.");
      } finally {
        alert("Changed");
        this.loadData();
        // this.$router.push("confirmdetails");
        // this.$router.push("/finance/final/checkout");
      }
    },
  },
  computed: {
    maxDateOfBirth() {
      return moment()
        .subtract(365 * 18, "days")
        .format("YYYY-MM-DD");
    },
    coapplicantRequired() {
      if (
        moment().diff(this.obj.dateOfBirth, "days") > 365 * 18 &&
        moment().diff(this.obj.dateOfBirth, "days") < 365 * 21
      ) {
        return true;
      } else {
        return false;
      }
    },
    dpCalc() {
      if (
        (this.schemeSelected.minDp / 100) * this.vehicleSelected.MOP >
        this.obj.marginmoney
      ) {
        return {
          valid: false,
          message:
            "LTV is not Enough - min " +
            (this.schemeSelected.minDp / 100) * this.vehicleSelected.MOP +
            " required.",
        };
      } else if (
        (this.schemeSelected.maxDp / 100) * this.vehicleSelected.MOP <
        this.obj.marginmoney
      ) {
        return {
          valid: false,
          message:
            "LTV is high - max " +
            (this.schemeSelected.maxDp / 100) * this.vehicleSelected.MOP +
            " allowed.",
        };
      } else {
        return {
          valid: true,
          message: "LTV provided is okay!",
        };
      }
    },
  },
};
</script>
<style>
.border-right {
  border-right: 1px solid rgb(214, 214, 214);
}
</style>
